export { HeroSection } from "./HeroSection";
export { AboutSection } from "./AboutSection";
export { WhyErdxSection } from "./WhyErdxSection";
export { SampleInventorySection } from "./SampleInventorySection";
export { MotorcycleAvailabilitySection } from "./MotorcycleAvailabilitySection";
export { AskAboutSection } from "./AskAboutSection";
export { LandingPageFooter } from "./LandingPageFooter";
export { ForgotPasswordDialog } from "./ForgotPasswordDialog";
